import { http } from 'utils'
import { map } from 'lodash'

// Configuration mutation imports.
import { SET_CONFIGURATIONS } from 'vx/mutations'

// Configuration state.
const state = {
  configurations: []
}

// Configuration state getters.
const getters = {
  /**
   * Selectable configurations for selectize.
   *
   * @param object state
   *
   * @return array
   */
  configurationOptions (state) {
    return map(state.configurations, configuration => ({ id: configuration.id, text: configuration.description }))
  }
}

// Configuration actions.
const actions = {
  /**
  * Get a list of configurations based on user
  *
  * @param Function commit
  *
  * @return Promise
  */
  getConfigurations ({ commit }) {
    return http.get(`configurations`).then(response => {
      commit(SET_CONFIGURATIONS, response.data)

      return response
    })
  }
}

// Configuration state mutations.
const mutations = {
  /**
  * Set the authorized user object.
  *
  * @return void
  */
  [SET_CONFIGURATIONS] (state, configurations) {
    state.configurations = configurations
  }
}

// Export our state, getters, actions, and mutations.
export default {
  namespaced: true, state, getters, actions, mutations
}



// WEBPACK FOOTER //
// ./src/vuex/modules/truck/configuration.js